import { __decorate, __metadata } from "tslib";
import { RegisterServiceError } from '../error/decorators.js';
import ServiceError from '../error/ServiceError.js';
import { BaseMessage } from '../message/BaseMessage.js';
import { Field, Message } from '../message/decorators.js';
import { MessageField } from '../message/index.js';
import { STATUS } from './enums.js';
let ValidationErrorMessage = class ValidationErrorMessage extends BaseMessage {
    keyword;
    dataPath;
    message;
    errorCode;
    allowedValues;
};
__decorate([
    Field.string({ required: true }),
    __metadata("design:type", String)
], ValidationErrorMessage.prototype, "keyword", void 0);
__decorate([
    Field.string({ required: true }),
    __metadata("design:type", String)
], ValidationErrorMessage.prototype, "dataPath", void 0);
__decorate([
    Field.string(),
    __metadata("design:type", String)
], ValidationErrorMessage.prototype, "message", void 0);
__decorate([
    Field.string(),
    __metadata("design:type", String)
], ValidationErrorMessage.prototype, "errorCode", void 0);
__decorate([
    Field.array({
        items: {
            type: 'string',
        },
        required: false,
    }),
    __metadata("design:type", Array)
], ValidationErrorMessage.prototype, "allowedValues", void 0);
ValidationErrorMessage = __decorate([
    Message({
        description: 'Validation errors found in the request message',
    })
], ValidationErrorMessage);
export { ValidationErrorMessage };
let ValidationErrorsMessage = class ValidationErrorsMessage extends BaseMessage {
    errors;
};
__decorate([
    Field.array({
        items: new MessageField({ required: true, message: ValidationErrorMessage }),
        required: true,
    }),
    __metadata("design:type", Array)
], ValidationErrorsMessage.prototype, "errors", void 0);
ValidationErrorsMessage = __decorate([
    Message({
        description: 'Validation errors found in the request message',
    })
], ValidationErrorsMessage);
export { ValidationErrorsMessage };
let ValidationError = class ValidationError extends ServiceError {
};
ValidationError = __decorate([
    RegisterServiceError({
        status: STATUS.UNPROCESSABLE_ENTITY,
        message: 'Validation error',
        responseClass: ValidationErrorsMessage,
    })
], ValidationError);
export { ValidationError };
let NotImplementedError = class NotImplementedError extends ServiceError {
};
NotImplementedError = __decorate([
    RegisterServiceError({
        status: STATUS.NOT_IMPLEMENTED,
        message: 'Not Implemented',
    })
], NotImplementedError);
export { NotImplementedError };
let InternalServiceError = class InternalServiceError extends ServiceError {
};
InternalServiceError = __decorate([
    RegisterServiceError({
        status: STATUS.INTERNAL_SERVER_ERROR,
        message: 'Internal server Error',
    })
], InternalServiceError);
export { InternalServiceError };
let DefaultBadRequestError = class DefaultBadRequestError extends ServiceError {
};
DefaultBadRequestError = __decorate([
    RegisterServiceError({
        status: STATUS.BAD_REQUEST,
        message: 'Bad Request Error',
    })
], DefaultBadRequestError);
export { DefaultBadRequestError };
let DefaultUnauthorizedError = class DefaultUnauthorizedError extends ServiceError {
};
DefaultUnauthorizedError = __decorate([
    RegisterServiceError({
        status: STATUS.UNAUTHORIZED,
        message: 'Unauthorized Error',
    })
], DefaultUnauthorizedError);
export { DefaultUnauthorizedError };
let DefaultNotFoundError = class DefaultNotFoundError extends ServiceError {
};
DefaultNotFoundError = __decorate([
    RegisterServiceError({
        status: STATUS.NOT_FOUND,
        message: 'Not Found Error',
    })
], DefaultNotFoundError);
export { DefaultNotFoundError };
let DefaultMethodNotAllowedError = class DefaultMethodNotAllowedError extends ServiceError {
};
DefaultMethodNotAllowedError = __decorate([
    RegisterServiceError({
        status: STATUS.METHOD_NOT_ALLOWED,
        message: 'Method Not Allowed Error',
    })
], DefaultMethodNotAllowedError);
export { DefaultMethodNotAllowedError };
let DefaultNotAcceptableError = class DefaultNotAcceptableError extends ServiceError {
};
DefaultNotAcceptableError = __decorate([
    RegisterServiceError({
        status: STATUS.NOT_ACCEPTABLE,
        message: 'Not Acceptable Error',
    })
], DefaultNotAcceptableError);
export { DefaultNotAcceptableError };
let DefaultTooManyRequestsError = class DefaultTooManyRequestsError extends ServiceError {
};
DefaultTooManyRequestsError = __decorate([
    RegisterServiceError({
        status: STATUS.TOO_MANY_REQUESTS,
        message: 'Too many requests',
    })
], DefaultTooManyRequestsError);
export { DefaultTooManyRequestsError };
let DefaultServiceUnavailableError = class DefaultServiceUnavailableError extends ServiceError {
};
DefaultServiceUnavailableError = __decorate([
    RegisterServiceError({
        status: STATUS.SERVICE_UNAVAILABLE,
        message: 'Service Unavailable',
    })
], DefaultServiceUnavailableError);
export { DefaultServiceUnavailableError };
//# sourceMappingURL=defaultErrors.js.map